import { EinfachauswahlAnsicht, MehrfachauswahlAnsicht } from "./Auswahl";
import {
  DatumAnsicht,
  FreitextAnsicht,
  PostleitzahlAnsicht,
  ZahlAnsicht,
} from "./Eingaben";
import type { SchrittProps } from "./gemeinsam";
import { EinwilligungAnsicht, InformationAnsicht, KontaktAnsicht } from "./Kontakt";

export type { SchrittProps } from "./gemeinsam";

/**
 * Der Verteiler auf die neun Fragetypen.
 *
 * Die Fallunterscheidung steht bewusst an einer einzigen Stelle. Wird das
 * Schema später um einen Typ erweitert, meldet TypeScript hier den fehlenden
 * Zweig, statt dass zur Laufzeit ein leerer Bildschirm erscheint.
 */
export function SchrittAnsicht(props: SchrittProps) {
  const { schritt } = props;

  switch (schritt.type) {
    case "single_choice":
      return <EinfachauswahlAnsicht {...props} schritt={schritt} />;
    case "multiple_choice":
      return <MehrfachauswahlAnsicht {...props} schritt={schritt} />;
    case "text":
      return <FreitextAnsicht {...props} schritt={schritt} />;
    case "number":
      return <ZahlAnsicht {...props} schritt={schritt} />;
    case "postcode":
      return <PostleitzahlAnsicht {...props} schritt={schritt} />;
    case "date":
      return <DatumAnsicht {...props} schritt={schritt} />;
    case "contact":
      return <KontaktAnsicht {...props} schritt={schritt} />;
    case "consent":
      return <EinwilligungAnsicht {...props} schritt={schritt} />;
    case "information":
      return <InformationAnsicht {...props} schritt={schritt} />;
  }
}
